import React from "react";
import {
   UserContextProvider,
   UserPreferencesContextProvider,
   AppContextProvider,
   OntologyContextProvider,
} from "../utilities/contexts";

export default function MainRouterContexts(props) {
   return (
      <UserContextProvider>
         <UserPreferencesContextProvider>
            <AppContextProvider>
               <OntologyContextProvider>
                  {props.children}
               </OntologyContextProvider>
            </AppContextProvider>
         </UserPreferencesContextProvider>
      </UserContextProvider>
   );
}
